module.exports = __webpack_public_path__ + "static/img/timg.c0964c3.gif";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/t-carousel/timg.gif
// module id = 4Ylk
// module chunks = 1